export default __webpack_public_path__ + "static/fernie-canada-ed9a15fc48661c0067ab869cd3df1699.jpg";